/* eslint-disable no-magic-numbers */
import type { ApiError } from '@omnipresentgroup/api';
import { List, Stack, Typography } from '@omnipresentgroup/design-system';

export const NotifyErrorDescription = ({ error }: { error: ApiError }) => {
  return (
    <Stack gap="4">
      <Typography as="span" color="subtle" size="14">
        {error.detail}
      </Typography>
      {error.problems && error.problems?.length > 0 && (
        <List
          showDisc
          gap="0"
          items={error.problems.map((problem, index) => ({
            id: `problem-${index}`,
            name: problem.detail,
          }))}
          keyExtractor="id"
          render={(item) => (
            <Typography as="span" size="14" color="subtle">
              {item.name}
            </Typography>
          )}
        />
      )}
    </Stack>
  );
};
